<template>
  <div ref="collapseRef">
    <p class="pt-1 text-error typo-subtitle-sm">
      {{ error }}
    </p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  error: {
    type: String,
    default: null,
  },
})

const collapseRef = ref<HTMLElement | undefined>(undefined)
const options = {
  duration: 300,
  initiallyClosed: true,
}

const open = useCollapse(collapseRef, options)

watch(() => props.error, () => {
  if (props.error) {
    open.value = true
  } else {
    open.value = false
  }
})
</script>
